const STORAGE_PREFIX = "table_column_order_";

export const TABLE_COLUMN_TABLE_IDS = {
  HOLDING_BOOK: "holding_book",
  POSITION_BOOK: "position_book",
  ORDER_BOOK: "order_book",
  BULK_ORDER: "bulk_order",
};

export const TABLE_COLUMN_PREFERENCES_CHANGED = "table-column-preferences-changed";

function storageKey(tableId) {
  return `${STORAGE_PREFIX}${tableId}`;
}

export function getSavedColumnKeys(tableId) {
  try {
    const raw = localStorage.getItem(storageKey(tableId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;
    return parsed.filter((k) => typeof k === "string" && k.length > 0);
  } catch {
    return null;
  }
}

export function saveColumnKeys(tableId, keys) {
  const normalized = Array.isArray(keys)
    ? keys.filter((k) => typeof k === "string" && k.length > 0)
    : [];
  if (normalized.length === 0) {
    localStorage.removeItem(storageKey(tableId));
  } else {
    localStorage.setItem(storageKey(tableId), JSON.stringify(normalized));
  }
  window.dispatchEvent(
    new CustomEvent(TABLE_COLUMN_PREFERENCES_CHANGED, { detail: { tableId } })
  );
}

export function clearColumnKeys(tableId) {
  localStorage.removeItem(storageKey(tableId));
  window.dispatchEvent(
    new CustomEvent(TABLE_COLUMN_PREFERENCES_CHANGED, { detail: { tableId } })
  );
}

/** Reorder API column definitions using saved key order; append new API columns at the end. */
export function applySavedColumnOrder(columns, tableId) {
  if (!Array.isArray(columns) || columns.length === 0) return columns;
  const saved = getSavedColumnKeys(tableId);
  if (!saved?.length) return columns;

  const byKey = new Map(columns.map((col) => [col.key, col]));
  const ordered = [];
  const seen = new Set();

  for (const key of saved) {
    const col = byKey.get(key);
    if (col) {
      ordered.push(col);
      seen.add(key);
    }
  }

  for (const col of columns) {
    if (!seen.has(col.key)) ordered.push(col);
  }

  return ordered;
}

/** Keys in display order: saved preference merged with API columns, else API order. */
export function resolveDisplayColumnKeys(apiColumns, tableId) {
  if (!Array.isArray(apiColumns) || apiColumns.length === 0) return [];
  const ordered = applySavedColumnOrder(apiColumns, tableId);
  return ordered.map((c) => c.key).filter(Boolean);
}

export function reorderKeys(keys, fromIndex, direction) {
  const list = [...keys];
  const toIndex = direction === "up" ? fromIndex - 1 : fromIndex + 1;
  if (toIndex < 0 || toIndex >= list.length) return list;
  const [item] = list.splice(fromIndex, 1);
  list.splice(toIndex, 0, item);
  return list;
}

export function moveKeyInList(keys, fromIndex, toIndex) {
  if (
    fromIndex === toIndex ||
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= keys.length ||
    toIndex >= keys.length
  ) {
    return keys;
  }
  const list = [...keys];
  const [item] = list.splice(fromIndex, 1);
  list.splice(toIndex, 0, item);
  return list;
}
